import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Checkbox, IconButton, ListRow } from 'basic-components';
import { AddRow } from 'basic-components/icons';
import { ReduxService } from 'dashboard-services/services';

import Pipi from 'primary/Pipi';

import classNames from 'classnames';
import './SuggestedRow.scss';

const emptyFun = () => {}
const SuggestedRow = ({ symbol, symbolIndex, addToBasket, isSelected = false, isPatternSelected = false, handleOpenAddDatapointModal, disabled = false }) => {
  const [isOverflowed, setIsOverflowed] = useState(false),
        addToBasketLocal = useCallback(() => addToBasket(ReduxService.updateObject(symbol, { pattern: "false" })), [addToBasket, symbol]),
        handleOpenAddDatapointModalLocal = useCallback(() => handleOpenAddDatapointModal(symbol), [handleOpenAddDatapointModal, symbol]),
        taskPaneWidth = useSelector(state => state.globalState.taskPaneWidth),
        timeoutRef = useRef(),
        ref = useRef(),
        contentProps = useMemo(() => ({ ref }), [])

  useEffect(() => {
    if(ref.current) {
      setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
    } else {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = window.setTimeout(() => setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth), 5)
    }
  }, [taskPaneWidth])

  useEffect(() => () => {
    window.clearTimeout(timeoutRef.current)
  }, [])

  return (
    <ListRow
        afterChildren={(
          <div className="ng-office-app__authed__content__starting__block__content__suggested-row__add-datapoint-container">
            <IconButton onClick={handleOpenAddDatapointModalLocal}>
              <AddRow
                  color="blue-bright"
              />
            </IconButton>
          </div>
        )}
        beforeChildren={(
          <Fragment key={symbolIndex}>
            <Pipi isPatternSelected={isPatternSelected}/>
            <Checkbox
                aria-label={symbol.symbols[symbol.mainSymbolKey]}
                checked={isSelected || isPatternSelected}
                disabled={isPatternSelected}
                onChange={emptyFun}
                onClick={addToBasketLocal}
            />
          </Fragment>
        )}
        className={classNames(
          "ng-office-app__authed__content__starting__block__content__suggested-row",
          { "ng-office-app__authed__content__starting__block__content__suggested-row--is-selected": isSelected },
          { "ng-office-app__authed__content__starting__block__content__suggested-row--is-overflowed": isOverflowed },
          { "ng-office-app__authed__content__starting__block__content__suggested-row--is-disabled": disabled },
        )}
        contentProps={contentProps}
        height={44}
        offset={8000}
        onClick={addToBasketLocal}
        unmountIfInvisible={false}
    >
      <div className="ng-office-app__authed__content__starting__block__content__suggested-row__content">
        <div
            className="ng-office-app__authed__content__starting__block__content__suggested-row__cell"
        >
          {symbol.symbols[symbol.mainSymbolKey]}
        </div>
        {(symbol.displayFields || []).map(field => (
          <div
              className={classNames(
                "ng-office-app__authed__content__starting__block__content__suggested-row__cell",
                { "ng-office-app__authed__content__starting__block__content__suggested-row__cell--is-overflowed": isOverflowed }
              )}
              key={`${field.source} + ${field.key} + ${symbolIndex}`}
          >
            <div className="ng-office-app__authed__content__starting__block__content__suggested-row__cell__label">{field.key}:</div>
            <div className="ng-office-app__authed__content__starting__block__content__suggested-row__cell__value">{symbol[field.source][field.key]}</div>
          </div>
        ))}
      </div>
    </ListRow>
  )
}

SuggestedRow.propTypes = {
  addToBasket: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  handleOpenAddDatapointModal: PropTypes.func.isRequired,
  isPatternSelected: PropTypes.bool,
  isSelected: PropTypes.bool,
  symbol: PropTypes.object.isRequired,
  symbolIndex: PropTypes.number.isRequired
}

export default SuggestedRow;